/* eslint-disable react/prefer-stateless-function */
import { Component } from 'react';
import classNames from 'classnames';
import PT from 'prop-types';

import styles from './deleteSittingButton.scss';

// cannot be stateless for UniqueOverlayTrigger targeting reasons
class DeleteSittingButton extends Component {
  render() {
    const { isShown, ...passedProps } = this.props;
    const cx = classNames(styles.buttonIcon, {
      [styles.active]: isShown,
    });
    return (
      <span className={cx} {...passedProps} data-test="delete-sitting-button">
        <i className="icon-bin" />
      </span>
    );
  }
}

export default DeleteSittingButton;

DeleteSittingButton.propTypes = {
  isShown: PT.bool,
};
